<template>
  <Screen title="choose your fold">
    <h2 class="fold-heading" aria-label="choose your fold">
      <span class="fold-heading__shadow">choose your fold</span>
      <span class="fold-heading__text">choose your fold</span>
    </h2>
    <ul class="folds">
      <li :class="[ 'fold', 'drafting-border', fold.name ]" v-for="fold in folds" :key="fold.name" @click="selectFold(fold)">
        <img :src="fold.svg.src" :style="foldStyle(fold)" />
      </li>
    </ul>
    <!-- Footer -->
    <footer class="app-footer">
      <div class="footer-top">
        <button class="back-to-top-btn" @click="$el.scrollIntoView()">Back to top</button>
      </div>
      <div class="footer-middle">
        <div class="footer-left">
          <button class="footer-link footer-link--btn" @click="$store.commit('setScreen', 'FoldingDirectionsScreen')">Folding directions</button>
          <a class="footer-link" href="?screen=HowToUseScreen" target="_blank">How to use</a>
          <a class="footer-email" href="mailto:Hi@roxanneg.design">Hi@roxanneg.design</a>
        </div>
        <div class="footer-social">
          <a href="https://www.linkedin.com/in/roxanne-g-ux/" class="footer-link" target="_blank" rel="noopener">linkedIN</a>
          <a href="https://github.com/boutell/diy-cardmaker/issues" class="footer-link" target="_blank" rel="noopener">submit a bug</a>
        </div>
      </div>
      <div class="footer-credits">
        <a href="https://roxanneg.design" class="footer-link" target="_blank" rel="noopener">roxanneg.design</a>
        <a href="https://boutell.dev" class="footer-link" target="_blank" rel="noopener">boutell.dev</a>
        <a href="https://www.anthropic.com/news/claude-sonnet-4-6" class="footer-link" target="_blank" rel="noopener">claude code</a>
      </div>
    </footer>
  </Screen>
</template>

<script>
import Screen from './Screen.vue';
import Trifold from '../assets/folds/trifold.svg';
import BifoldVertical from '../assets/folds/bifold-vertical.svg';
// import LinearQuad from '../assets/folds/linear-quad.svg';
import QuarterFold from '../assets/folds/quarter-fold.svg';
import BifoldEasel from '../assets/folds/bifold-easel.svg';
// import Triptych from '../assets/folds/triptych.svg';

export default {
  components: {
    Screen
  },
  data() {
    return {
      folds: [
        {
          name: 'trifold',
          label: 'Trifold',
          svg: {
            src: Trifold,
            scale: 1.0
          },
          back: false,
          width: 2.66666666666666 * 72,
          height: 7.5 * 72,
          pages: [
            {
              // For PDF generation
              x: 0.5 * 72,
              y: 0.5 * 72,
              rotate: 90,
              side: 0
            },
            {
              x: 0.5 * 72,
              y: (1.5 + 2.66666666666666) * 72,
              rotate: 90,
              side: 0
            },
            {
              x: 0.5 * 72,
              y: (2.5 + 2.66666666666666 * 2) * 72,
              rotate: 90,
              side: 0
            }
          ]
        },
        {
          name: 'bifold-vertical',
          label: 'Bifold Vertical',
          svg: {
            src: BifoldVertical,
            translate: -1,
            scale: 0.95
          },
          back: false,
          width: 4.5 * 72,
          height: 7.5 * 72,
          pages: [
            {
              x: 0.5 * 72,
              y: 6.0 * 72,
              rotate: 90,
              side: 0
            },
            {
              x: 0.5 * 72,
              y: 0.5 * 72,
              rotate: 90,
              side: 1
            },
            {
              x: 0.5 * 72,
              y: 6.0 * 72,
              rotate: 90,
              side: 1
            },
            {
              x: 0.5 * 72,
              y: 0.5 * 72,
              rotate: 90,
              side: 0
            }
          ],
        },
        // {
        //   name: 'linear-quad',
        //   label: 'Linear Quad',
        //   svg: {
        //     src: LinearQuad,
        //     scale: 0.9
        //   },
        //   pages: 4,
        //   back: 'back'
        // },
        {
          name: 'quarter-fold',
          label: 'Quarter Fold',
          svg: {
            src: QuarterFold,
            scale: 0.9,
            translate: 3
          },
          back: false,
          width: 3.25 * 72,
          height: 4.5 * 72,
          pages: [
            {
              x: 4.75 * 72,
              y: 6 * 72,
              rotate: 0,
              side: 0
            },
            {
              x: 4.75 * 72,
              y: 0.5 * 72,
              rotate: 180,
              side: 0
            },
            {
              x: 0.5 * 72,
              y: 0.5 * 72,
              rotate: 180,
              side: 0
            },
            {
              x: 0.5 * 72,
              y: 6.0 * 72,
              rotate: 0,
              side: 0
            },
          ]
        },
        {
          name: 'bifold-easel',
          label: 'Bifold Easel',
          svg: {
            src: BifoldEasel,
            scale: 0.95
          },
          back: false,
          width: 7.5 * 72,
          height: 4.5 * 72,
          pages: [
            {
              x: 0.5 * 72,
              y: 0.5 * 72,
              rotate: 180,
              side: 0
            },
            {
              x: 0.5 * 72,
              y: 6.0 * 72,
              rotate: 0,
              side: 0
            }
          ]
        },
        // {
        //   name: 'triptych',
        //   label: 'Triptych',
        //   svg: {
        //     src: Triptych,
        //     scale: 1.0
        //   },
        //   pages: 3,
        //   back: false
        // }
      ],
      fold: null
    }
  },
  methods: {
    foldStyle(fold) {
      const transform = `scale(${fold.svg.scale || 1.0}) translate(0, ${fold.svg.translate || 0.0}%)`;
      return {
        transform,
        transformOrigin: 'top center'
      };
    },
    selectFold(fold) {
      this.$store.commit('setFold', fold);
      this.$store.commit('setScreen', 'PersonalizeScreen');
    }
  }
}
</script>
<style scoped>
  .folds {
    margin-block-start: 0;
    margin-block-end: 0;
    padding: 0;
    padding-inline-start: 0;
    list-style-type: none;
    display: grid;
    grid-gap: 16px 29px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    /*
      Fixed height = full viewport minus nav (56px) minus content margin (16px)
      minus heading (84px) minus heading margin (16px) = 100vh - 172px
    */
    height: calc(100vh - 172px);
    width: 80%;
    margin: 0 auto;
  }
  .fold {
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    min-height: 0;
  }
  .label {
    margin-top: 6px;
    font-weight: bold;
    text-align: center;
  }
  .fold img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
  }
  ::-webkit-scrollbar {
      display: none;
  }

  /* Hide the nav bar title text — this screen has its own heading */
  :deep(.title) {
    display: none;
  }

  /* Remove all drafting-border strokes from fold cards — SVGs are transparent */
  .fold.drafting-border {
    border: none;
    filter: none;
  }
  .fold.drafting-border::before,
  .fold.drafting-border::after {
    display: none;
  }

  /* ── Standalone heading ──
     Two-layer text effect matching Figma:
     Layer 1 (shadow): --surface-darkest (near-black) offset 6-8px down-right
     Layer 2 (foreground): --green-lightest (near-white) with --surface-darkest stroke
     Together they create a light-text-on-dark-shadow depth effect.
  */
  .fold-heading {
    position: relative;
    font-family: Cabin-Sketch, cursive;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.01em;
    border: none;
    min-height: 60px;
    width: 90%;
    margin: 0 auto 16px;
    flex-shrink: 0;
    font-size: 80px;
    line-height: 1.1;
    text-align: center;
  }

  /* Shadow/underpainting layer — near-black, offset down-right */
  .fold-heading__shadow {
    position: absolute;
    left: 6px;
    top: 6px;
    width: 100%;
    color: var(--surface-darkest);
    -webkit-text-stroke: 0;
  }

  /* Foreground layer — near-white fill with dark outline */
  .fold-heading__text {
    position: relative;
    display: block;
    width: 100%;
    color: var(--green-lightest);
    -webkit-text-stroke: 1px var(--surface-darkest);
    paint-order: stroke fill;
  }

  /* ── Responsive heading ── */
  @media screen and (max-width: 960px) {
    .fold-heading {
      font-size: 64px;
      height: 48px;
      line-height: 48px;
    }
  }

  /* Mobile (≤420px): 32px font */
  @media screen and (max-width: 420px) {
    .fold-heading {
      font-size: 32px;
      min-height: auto;
      white-space: normal;
      line-height: 1.1;
      padding: 8px 16px;
    }
    /* Scale the shadow offset down by half for the smaller font */
    .fold-heading__shadow {
      left: 3px;
      top: 3px;
    }
  }

  /* ── Responsive grid ── */
  @media screen and (max-width: 480px) {
    .folds {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      width: 80%;
    }
  }

  @media screen and (min-width: 481px) and (max-width: 768px) {
    .folds {
      grid-template-columns: auto auto;
      grid-template-rows: auto auto;
      width: 70%;
    }
  }

  @media screen and (min-width: 769px) {
    .folds {
      grid-template-columns: auto auto;
      grid-template-rows: auto auto;
    }
  }

  /* ── Footer ── */
  .app-footer {
    flex-shrink: 0;
    background-color: var(--surface-darkest);
    padding: 32px 56px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-end;
    font-family: var(--font-family-balsamiq);
    font-size: var(--font-size-16);
    color: var(--text-bright);
  }

  .footer-top {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  /* Back to top button — Figma hand-drawn border via custom SVG filter */
  .back-to-top-btn {
    background-color: var(--surface-darkest);
    border: 2px solid var(--text-bright);
    color: var(--text-bright);
    font-family: var(--font-family-balsamiq);
    font-size: var(--font-size-16);
    line-height: var(--font-line-height-24);
    padding: 7px 16px;
    border-radius: 1px;
    cursor: pointer;
    filter: url(#button-stroke);
  }

  .footer-middle {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
  }

  /* All footer links — always aqua-bright, overrides browser :link blue */
  .footer-email,
  .footer-link {
    color: var(--text-bright) !important;
    font-size: var(--font-size-16);
    line-height: var(--font-line-height-24);
    text-decoration: underline;
    text-decoration-skip-ink: none;
    white-space: nowrap;
  }

  .footer-email:link,
  .footer-link:link,
  .footer-email:visited,
  .footer-link:visited,
  .footer-email:active,
  .footer-link:active {
    color: var(--text-bright) !important;
  }

  .footer-email:hover,
  .footer-link:hover {
    color: var(--text-lightest) !important;
  }

  .footer-left {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  /* Button that visually matches footer links */
  .footer-link--btn {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .footer-link--disabled {
    opacity: 0.45;
    cursor: default;
  }

  .footer-social {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-end;
    text-align: right;
  }

  .footer-credits {
    display: flex;
    gap: 24px;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
  }

  /* Mobile footer (<= 560px) */
  @media screen and (max-width: 560px) {
    .app-footer {
      padding: 32px 40px; /* matched to Figma px-[40px] py-[32px] */
      align-items: center;
      text-align: center;
      gap: 32px;
    }

    .footer-top {
      justify-content: center;
    }

    .footer-middle {
      flex-direction: column;
      align-items: center;
      gap: 32px;
    }

    .footer-left {
      align-items: center;
    }

    .footer-social {
      align-items: center;
      text-align: center;
      gap: 16px;
    }

    .footer-credits {
      /* Add top separator line with hand-drawn wobble */
      position: relative;
      margin-top: 16px;
      padding-top: 32px; /* space between line and text */

      /* wrap side-by-side per Figma */
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-end;
      align-content: flex-end;
      gap: 24px;
    }

    /* Top separator — uses hand-drawn-line filter for wavy effect */
    .footer-credits::before {
      content: '';
      position: absolute;
      /* Place line perfectly at the top edge of this container */
      top: 0;
      left: 0;
      right: 0;
      height: 16px;
      /* Only the middle 1px appears as the line; rest is transparent for the filter */
      background: linear-gradient(
        to bottom,
        transparent calc(50% - 0.5px),
        var(--text-bright) calc(50% - 0.5px),
        var(--text-bright) calc(50% + 0.5px),
        transparent calc(50% + 0.5px)
      );
      filter: url(#hand-drawn-line);
      pointer-events: none;
      z-index: 1;
    }
  }
</style>